const initialState = {
    isOpen : false,
    type:''
}

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CLOSE_MODAL':
            return {
                ...state,
                isOpen: false,
                type:''
            }

        case 'OPEN_LOGIN_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'LOGIN'
            }
      
        case 'OPEN_EDIT_MODAL':
          return {
              ...state,
              isOpen: true,
              type:'EDIT'
          }

        case 'OPEN_SHARE_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'SHARE'
            }
        
        case 'OPEN_MESSENGER_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'MESSENGER'
            }
        
            
        case 'OPEN_CONTACT_ALOHADOR_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'CONTACT_ALOHADOR'
            }    
        case 'OPEN_REGISTER_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'REGISTER'
            }
        case 'OPEN_SUCCESS_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'SUCCESS'
            }
        case 'OPEN_CANCEL_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'CANCEL'
            }
        case 'OPEN_PHONE_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'PHONE'
            }
        case 'OPEN_RESET_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'RESET'
            }
        case 'OPEN_CANCELATION_RESERVATION_MODAL':
            return {
                ...state,
                isOpen: true,
                type:'CANCELATION_RESERVATION'
            }
        default:
            return state
    }
}

export default modalReducer;
